import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import ItemInfo from "./ItemInfo";
import Items from "./Items";
import Locations from "./Location";
import Pricing from "./Pricing";
import Images from "./Images";
import Details from "./Details";

const Manageitemskit = () => {
  const [loading, setLoading] = useState(false);
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignUser = (val) => {
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  const handleComplete = () => {
    alert("You r done. TQ");
  };

  useEffect(() => {
    if (stepWizard !== null) {
      setActiveStep(stepWizard.currentStep - 1);
    }
  }, [stepWizard]);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="card">
          <div className="content container-fluid card-body">
            <div className="row">
              <div className="col">
                <h4 className="page-title">New Items Kit</h4>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/item-Kits">Items Kit List</Link>
                  </li>
                  <li className="breadcrumb-item active">Manage Item Kits</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="card ">
            <div className="card-body">
              <Stepper activeStep={activeStep}>
                <Step
                  onClick={() => {
                    setActiveStep(0);
                    stepWizard.goToStep(1);
                  }}
                  label="Item Kit Info"
                />
                <Step
                  onClick={() => {
                    setActiveStep(1);
                    stepWizard.goToStep(2);
                  }}
                  label="Details"
                />
                <Step
                  onClick={() => {
                    setActiveStep(2);
                    stepWizard.goToStep(3);
                  }}
                  label="Items"
                />
                <Step
                  onClick={() => {
                    setActiveStep(3);
                    stepWizard.goToStep(4);
                  }}
                  label="Pricing"
                />
                <Step
                  onClick={() => {
                    setActiveStep(4);
                    stepWizard.goToStep(5);
                  }}
                  label="Images"
                />
                <Step
                  onClick={() => {
                    setActiveStep(5);
                    stepWizard.goToStep(6);
                  }}
                  label="Locations"
                />
              </Stepper>

              <StepWizard
                instance={assignStepWizard}
                onStepChange={handleStepChange}
                initialStep={activeStep}
              >
                <ItemInfo userCallback={assignUser} />
                <Details user={user} userCallback={assignUser} />
                <Items user={user} userCallback={assignUser} />
                <Pricing user={user} userCallback={assignUser} />
                <Images user={user} userCallback={assignUser} />
                <Locations user={user} completeCallback={handleComplete} />
              </StepWizard>
            </div>
            {/* end card body */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Manageitemskit;
